__turbopack_context__.v({
  "captionDarkMode": "styles-module-scss-module__9FmSNG__captionDarkMode",
  "captionText": "styles-module-scss-module__9FmSNG__captionText",
  "gameDialogCaption": "styles-module-scss-module__9FmSNG__gameDialogCaption",
  "gameLandingCaption": "styles-module-scss-module__9FmSNG__gameLandingCaption",
});
